import {Components, ComponentService} from "../service/component";
import Events from "../service/events";
import EVENTS from "../constants/events";
import {AnimationService} from "../service/animation";
import {HistoryService} from "../service/history";

export class Application {

    public namespace:string;

    constructor(components:ComponentService, events?:Events, history?:HistoryService, animation?:AnimationService, namespace?:string, container?:HTMLElement) {
        if (namespace) {
            this.namespace = namespace;
        }
        this.initComponents(components, events, history, animation, container);
        Application.initFunctions();
        if (events) {
            events.addListener(
                EVENTS.APPLICATION_RELOAD,
                (container?: HTMLElement, namespaces?: string[]) => {
                    if (undefined === namespaces || -1 !== namespaces.indexOf(this.namespace)) {
                        this.initComponents(components, events, history, animation, container)
                    }
                }
            );
        }
        if (history) {
            history.start();
        }
    }

    /**
     * This sets up components linking an instance of the object to each selector defined in the component array above
     */
    initComponents = (components:ComponentService, events?:Events, history?:HistoryService, animation?: AnimationService, container?: HTMLElement) => {
        components.getComponents().forEach((component: Components) => {
            $(component.elements, container).each((key, element) => {
                let initialised = $(element).data('initialised') ? $(element).data('initialised') : [];
                if (!initialised.find((initialisedType:any) => initialisedType == component.componentName)) {
                    let object = new component.class(<HTMLElement>element);
                    if (events && typeof object.setEventHandler === 'function') {
                        object.setEventHandler(events);
                    }
                    if (animation && typeof object.setAnimationHandler === 'function') {
                        object.setAnimationHandler(animation);
                    }
                    if (history && typeof object.setHistoryHandler === 'function') {
                        object.setHistoryHandler(history);
                    }
                    if (component.callback) {
                        component.callback(object);
                    }
                    if (typeof object.init === 'function') {
                        object.init();
                    }
                    initialised.push(component.componentName);
                    $(element).data('initialised', initialised);
                }
            })
        });
    }

    public static initFunctions() {
        $('.no-js').removeClass('no-js').addClass('js');
    }
}